import {
  deserializeYesplanAPIDate,
  deserializeYesplanAPIDateAndTime
} from '../libs/dateTimeUtilities';
import { printInShortDateFormat } from '../libs/dateTimePrinting';

export default class YPAbstractEventObject {
  constructor(abstractEventJSON) {
    this.id = abstractEventJSON.id;
    this.name = abstractEventJSON.name;
    this.topGroupID = null;
    this.topGroupName = null;
    this.directGroupID = null;
    this.directGroupName = null;
    if (abstractEventJSON.parentgroup) {
      this.directGroupID = abstractEventJSON.parentgroup.id;
      this.directGroupName = abstractEventJSON.parentgroup.name;
    }
    if (abstractEventJSON.group && abstractEventJSON.group.id !== this.directGroupID) {
      this.topGroupID = abstractEventJSON.group.id;
      this.topGroupName = abstractEventJSON.group.name;
    }

    this.status = abstractEventJSON.status;
    this.profile = abstractEventJSON.profile;
    this.startDate = abstractEventJSON.startdate
      ? deserializeYesplanAPIDate(abstractEventJSON.startdate)
      : null;
    this.endDate = abstractEventJSON.enddate
      ? deserializeYesplanAPIDate(abstractEventJSON.enddate)
      : null;
    this.starttime = abstractEventJSON.starttime
      ? deserializeYesplanAPIDateAndTime(abstractEventJSON.starttime)
      : null;
    this.endtime = abstractEventJSON.endtime
      ? deserializeYesplanAPIDateAndTime(abstractEventJSON.endtime)
      : null;
    this.locations = abstractEventJSON.locations;
  }

  getDirectGroupNameOrPlaceholder() {
    return this.directGroupName || `(${[i18n('unnamed event group')]})`;
  }

  getTopGroupNameOrPlaceholder() {
    return this.topGroupName || `(${[i18n('unnamed event group')]})`;
  }

  getNameOfGroup() {
    if (this.topGroupID !== null) return this.getTopGroupNameOrPlaceholder();
    return this.getDirectGroupNameOrPlaceholder();
  }

  isPartOfGroup() {
    return this.hasDirectGroup();
  }

  hasDirectGroup() {
    return this.directGroupID !== null;
  }

  hasTopGroup() {
    return this.topGroupID !== null;
  }

  compareEventNames(otherEvent) {
    if (this.name === otherEvent.name) return this.id.localeCompare(otherEvent.id);
    return this.name.localeCompare(otherEvent.name);
  }

  printDateString(dateFormatSetting) {
    return printInShortDateFormat(this.startDate, dateFormatSetting);
  }

  printLocationsString() {
    return this.locations && this.locations.length > 0
      ? this.locations.map((loc) => loc.name)
      : [i18n('No location')];
  }

  printStatusString() {
    return this.status && this.status.name ? this.status.name : i18n('No Status');
  }

  printProfileString() {
    return this.profile && this.profile.name ? this.profile.name : i18n('No Profile');
  }
}
